import {
    FETCH_LOI_LIST_REQUEST,
    FETCH_LOI_LIST_SUCCESS,
    FETCH_LOI_LIST_FAILURE,
    CREATE_LOI_REQUEST,
    CREATE_LOI_SUCCESS,
    CREATE_LOI_FAILURE,
    UPDATE_LOI_REQUEST,
    UPDATE_LOI_SUCCESS,
    UPDATE_LOI_FAILURE,
  } from "../../../../actions/manage-property/property-loi/LOIDetails/types";
  
  const initialState = {
    createLoi: { loading: false, data: null, error: null },
    deleteLoi: { loading: false, data: null, error: null },
    updateLoi: { loading: false, data: null, error: null },
    loiList: { loading: false, data: null, error: null },
  };
  
  const LoiList = (state = initialState, action) => {
    // console.log(action.type);
    switch (action.type) {
      //  Request
      case CREATE_LOI_REQUEST:
        return {
          ...state,
          createLoi: { ...initialState.createLoi, loading: true },
        };
      case UPDATE_LOI_REQUEST:
        return {
          ...state,
          updateLoi: { ...initialState.updateLoi, loading: true },
        };
      case FETCH_LOI_LIST_REQUEST: {
        return {
          ...state,
          loiList: { ...initialState.loiList, loading: true },
        };
      }
  
  // Success 
      case CREATE_LOI_SUCCESS: {
        // console.log(state.loiList);
        return {
          ...state,
          createLoi: {
            ...state.createLoi,
            payload: action.payload,
            loading: false,
            error: null,
          },
          loiList: addNewLoiData(action.payload, {
            ...state.loiList,
          }),
        };
      }
  
      case UPDATE_LOI_SUCCESS: {
        return {
          ...state,
          updateLoi: {
            ...state.updateLoi,
            loading: false,
            error: null,
            payload: action.payload,
          },
          loiList: updateLoiData(action.payload, {
            ...state.loiList,
          }),
        };
      }
  
      case FETCH_LOI_LIST_SUCCESS: {
        // console.log(action.payload);
        return {
          ...state,
          loiList: {
            ...initialState.loiList,
            loading: false,
            error: null,
            data: action.payload,
          },
        };
      }
  
      //failure
      case FETCH_LOI_LIST_FAILURE:
        return {
          ...state,
          loiList: { data: null, loading: false, error: action.error },
        };
        case CREATE_LOI_FAILURE:
          return {
            ...state,
            createLoi: { data: null, loading: false, error: action.error }
          };
        case UPDATE_LOI_FAILURE:
          return {
            ...state,
            updateLoi: { data: null, loading: false, error: action.error }
          };
  
      default:
        return state;
    }
  };
  
  function updateLoiData(dataToUpdate, state) {
    state.data.data = state.data.data.map((obj) => {
      if (obj._id !== dataToUpdate._id) return obj;
      return { ...dataToUpdate };
    });
  
    return state;
  }
  
  
  function addNewLoiData(dataToUpdate, state) {
    state.data.data = [...state.data.data, dataToUpdate];
    state.data.total++;
    return state;
  }
  
  export default LoiList;
  